// extracted by mini-css-extract-plugin
module.exports = {"chip":"style_chip__lr_Hp"};